// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__-axgE","wrapper":"modal_wrapper__RPmel"};